// source: io/codedrills/proto/user/candidate.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_content_pb);
var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_preview_pb);
var io_codedrills_proto_content_view_pb = require('../../../../io/codedrills/proto/content/view_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_view_pb);
var io_codedrills_proto_user_candidate_status_pb = require('../../../../io/codedrills/proto/user/candidate_status_pb.js');
goog.object.extend(proto, io_codedrills_proto_user_candidate_status_pb);
goog.exportSymbol('proto.io.codedrills.proto.user.Answer', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.AnswerData', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.AnswerData.AnswerDataCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.AntiCheatingReport', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Candidate', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CandidateFeedback', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CandidateProfile', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CandidateReport', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CompleteAnswerData', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CompleteAnswerData.AnswerCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CompleteMcqAnswerData', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CompleteProblemAnswerData', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CurrentTestView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.JobCandidate', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.McqAnswerData', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.ProblemAnswerData', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.ProctoringEvent', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.ProctoringLog', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.QuestionAnswer', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Resume', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.SkillScore', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.SubjectiveAnswerData', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.TestQuestion', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.TimeInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Candidate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.Candidate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Candidate.displayName = 'proto.io.codedrills.proto.user.Candidate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CandidateProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.CandidateProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CandidateProfile.displayName = 'proto.io.codedrills.proto.user.CandidateProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CandidateReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.CandidateReport.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.CandidateReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CandidateReport.displayName = 'proto.io.codedrills.proto.user.CandidateReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.AntiCheatingReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.AntiCheatingReport.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.AntiCheatingReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.AntiCheatingReport.displayName = 'proto.io.codedrills.proto.user.AntiCheatingReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.SkillScore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.SkillScore.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.SkillScore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.SkillScore.displayName = 'proto.io.codedrills.proto.user.SkillScore';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.QuestionAnswer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.QuestionAnswer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.QuestionAnswer.displayName = 'proto.io.codedrills.proto.user.QuestionAnswer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CompleteAnswerData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.user.CompleteAnswerData.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.user.CompleteAnswerData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CompleteAnswerData.displayName = 'proto.io.codedrills.proto.user.CompleteAnswerData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.CompleteMcqAnswerData.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.CompleteMcqAnswerData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CompleteMcqAnswerData.displayName = 'proto.io.codedrills.proto.user.CompleteMcqAnswerData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.displayName = 'proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.CompleteProblemAnswerData.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.CompleteProblemAnswerData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CompleteProblemAnswerData.displayName = 'proto.io.codedrills.proto.user.CompleteProblemAnswerData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.TestQuestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.TestQuestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.TestQuestion.displayName = 'proto.io.codedrills.proto.user.TestQuestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.TimeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.TimeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.TimeInfo.displayName = 'proto.io.codedrills.proto.user.TimeInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Answer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.Answer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Answer.displayName = 'proto.io.codedrills.proto.user.Answer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.AnswerData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.user.AnswerData.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.user.AnswerData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.AnswerData.displayName = 'proto.io.codedrills.proto.user.AnswerData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.McqAnswerData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.McqAnswerData.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.McqAnswerData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.McqAnswerData.displayName = 'proto.io.codedrills.proto.user.McqAnswerData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.SubjectiveAnswerData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.SubjectiveAnswerData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.SubjectiveAnswerData.displayName = 'proto.io.codedrills.proto.user.SubjectiveAnswerData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.ProblemAnswerData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.ProblemAnswerData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.ProblemAnswerData.displayName = 'proto.io.codedrills.proto.user.ProblemAnswerData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.ProctoringLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.ProctoringLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.ProctoringLog.displayName = 'proto.io.codedrills.proto.user.ProctoringLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CandidateFeedback = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.CandidateFeedback, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CandidateFeedback.displayName = 'proto.io.codedrills.proto.user.CandidateFeedback';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CurrentTestView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.CurrentTestView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CurrentTestView.displayName = 'proto.io.codedrills.proto.user.CurrentTestView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Resume = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.Resume, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Resume.displayName = 'proto.io.codedrills.proto.user.Resume';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.JobCandidate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.JobCandidate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.JobCandidate.displayName = 'proto.io.codedrills.proto.user.JobCandidate';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Candidate.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Candidate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Candidate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Candidate.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    testId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    candidateId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    profile: (f = msg.getProfile()) && proto.io.codedrills.proto.user.CandidateProfile.toObject(includeInstance, f),
    stage: jspb.Message.getFieldWithDefault(msg, 7, 0),
    report: (f = msg.getReport()) && proto.io.codedrills.proto.user.CandidateReport.toObject(includeInstance, f),
    timeInfo: (f = msg.getTimeInfo()) && proto.io.codedrills.proto.user.TimeInfo.toObject(includeInstance, f),
    inviteDate: jspb.Message.getFieldWithDefault(msg, 10, 0),
    rating: jspb.Message.getFieldWithDefault(msg, 11, 0),
    notes: jspb.Message.getFieldWithDefault(msg, 12, ""),
    testStatus: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Candidate}
 */
proto.io.codedrills.proto.user.Candidate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Candidate;
  return proto.io.codedrills.proto.user.Candidate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Candidate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Candidate}
 */
proto.io.codedrills.proto.user.Candidate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTestId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCandidateId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.user.CandidateProfile;
      reader.readMessage(value,proto.io.codedrills.proto.user.CandidateProfile.deserializeBinaryFromReader);
      msg.setProfile(value);
      break;
    case 7:
      var value = /** @type {!proto.io.codedrills.proto.user.CandidateStage} */ (reader.readEnum());
      msg.setStage(value);
      break;
    case 8:
      var value = new proto.io.codedrills.proto.user.CandidateReport;
      reader.readMessage(value,proto.io.codedrills.proto.user.CandidateReport.deserializeBinaryFromReader);
      msg.setReport(value);
      break;
    case 9:
      var value = new proto.io.codedrills.proto.user.TimeInfo;
      reader.readMessage(value,proto.io.codedrills.proto.user.TimeInfo.deserializeBinaryFromReader);
      msg.setTimeInfo(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInviteDate(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRating(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 13:
      var value = /** @type {!proto.io.codedrills.proto.user.TestStatus} */ (reader.readEnum());
      msg.setTestStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Candidate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Candidate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Candidate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Candidate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTestId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCandidateId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProfile();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.io.codedrills.proto.user.CandidateProfile.serializeBinaryToWriter
    );
  }
  f = message.getStage();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getReport();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.io.codedrills.proto.user.CandidateReport.serializeBinaryToWriter
    );
  }
  f = message.getTimeInfo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.io.codedrills.proto.user.TimeInfo.serializeBinaryToWriter
    );
  }
  f = message.getInviteDate();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getRating();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTestStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
};


/**
 * optional int32 customer_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getCustomerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 test_id = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getTestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.setTestId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string candidate_id = 4;
 * @return {string}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getCandidateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.setCandidateId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional CandidateProfile profile = 6;
 * @return {?proto.io.codedrills.proto.user.CandidateProfile}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getProfile = function() {
  return /** @type{?proto.io.codedrills.proto.user.CandidateProfile} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.CandidateProfile, 6));
};


/**
 * @param {?proto.io.codedrills.proto.user.CandidateProfile|undefined} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
*/
proto.io.codedrills.proto.user.Candidate.prototype.setProfile = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.clearProfile = function() {
  return this.setProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Candidate.prototype.hasProfile = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional CandidateStage stage = 7;
 * @return {!proto.io.codedrills.proto.user.CandidateStage}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getStage = function() {
  return /** @type {!proto.io.codedrills.proto.user.CandidateStage} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.CandidateStage} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.setStage = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional CandidateReport report = 8;
 * @return {?proto.io.codedrills.proto.user.CandidateReport}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getReport = function() {
  return /** @type{?proto.io.codedrills.proto.user.CandidateReport} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.CandidateReport, 8));
};


/**
 * @param {?proto.io.codedrills.proto.user.CandidateReport|undefined} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
*/
proto.io.codedrills.proto.user.Candidate.prototype.setReport = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.clearReport = function() {
  return this.setReport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Candidate.prototype.hasReport = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional TimeInfo time_info = 9;
 * @return {?proto.io.codedrills.proto.user.TimeInfo}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getTimeInfo = function() {
  return /** @type{?proto.io.codedrills.proto.user.TimeInfo} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.TimeInfo, 9));
};


/**
 * @param {?proto.io.codedrills.proto.user.TimeInfo|undefined} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
*/
proto.io.codedrills.proto.user.Candidate.prototype.setTimeInfo = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.clearTimeInfo = function() {
  return this.setTimeInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Candidate.prototype.hasTimeInfo = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional int64 invite_date = 10;
 * @return {number}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getInviteDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.setInviteDate = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 rating = 11;
 * @return {number}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getRating = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.setRating = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string notes = 12;
 * @return {string}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional TestStatus test_status = 13;
 * @return {!proto.io.codedrills.proto.user.TestStatus}
 */
proto.io.codedrills.proto.user.Candidate.prototype.getTestStatus = function() {
  return /** @type {!proto.io.codedrills.proto.user.TestStatus} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.TestStatus} value
 * @return {!proto.io.codedrills.proto.user.Candidate} returns this
 */
proto.io.codedrills.proto.user.Candidate.prototype.setTestStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CandidateProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CandidateProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CandidateProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CandidateProfile.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CandidateProfile}
 */
proto.io.codedrills.proto.user.CandidateProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CandidateProfile;
  return proto.io.codedrills.proto.user.CandidateProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CandidateProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CandidateProfile}
 */
proto.io.codedrills.proto.user.CandidateProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CandidateProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CandidateProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CandidateProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CandidateProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.CandidateReport.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CandidateReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CandidateReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CandidateReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    candidateId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    testId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    profile: (f = msg.getProfile()) && proto.io.codedrills.proto.user.CandidateProfile.toObject(includeInstance, f),
    stage: jspb.Message.getFieldWithDefault(msg, 4, 0),
    testTimeInfo: (f = msg.getTestTimeInfo()) && proto.io.codedrills.proto.user.TimeInfo.toObject(includeInstance, f),
    inviteDate: jspb.Message.getFieldWithDefault(msg, 6, 0),
    overallScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    rating: jspb.Message.getFieldWithDefault(msg, 8, 0),
    skillScoresList: jspb.Message.toObjectList(msg.getSkillScoresList(),
    proto.io.codedrills.proto.user.SkillScore.toObject, includeInstance),
    antiCheatingReport: (f = msg.getAntiCheatingReport()) && proto.io.codedrills.proto.user.AntiCheatingReport.toObject(includeInstance, f),
    notes: jspb.Message.getFieldWithDefault(msg, 11, ""),
    testStatus: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CandidateReport}
 */
proto.io.codedrills.proto.user.CandidateReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CandidateReport;
  return proto.io.codedrills.proto.user.CandidateReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CandidateReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CandidateReport}
 */
proto.io.codedrills.proto.user.CandidateReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCandidateId(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTestId(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.user.CandidateProfile;
      reader.readMessage(value,proto.io.codedrills.proto.user.CandidateProfile.deserializeBinaryFromReader);
      msg.setProfile(value);
      break;
    case 4:
      var value = /** @type {!proto.io.codedrills.proto.user.CandidateStage} */ (reader.readEnum());
      msg.setStage(value);
      break;
    case 5:
      var value = new proto.io.codedrills.proto.user.TimeInfo;
      reader.readMessage(value,proto.io.codedrills.proto.user.TimeInfo.deserializeBinaryFromReader);
      msg.setTestTimeInfo(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInviteDate(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOverallScore(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRating(value);
      break;
    case 9:
      var value = new proto.io.codedrills.proto.user.SkillScore;
      reader.readMessage(value,proto.io.codedrills.proto.user.SkillScore.deserializeBinaryFromReader);
      msg.addSkillScores(value);
      break;
    case 10:
      var value = new proto.io.codedrills.proto.user.AntiCheatingReport;
      reader.readMessage(value,proto.io.codedrills.proto.user.AntiCheatingReport.deserializeBinaryFromReader);
      msg.setAntiCheatingReport(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 14:
      var value = /** @type {!proto.io.codedrills.proto.user.TestStatus} */ (reader.readEnum());
      msg.setTestStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CandidateReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CandidateReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CandidateReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCandidateId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTestId();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfile();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.io.codedrills.proto.user.CandidateProfile.serializeBinaryToWriter
    );
  }
  f = message.getStage();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTestTimeInfo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.io.codedrills.proto.user.TimeInfo.serializeBinaryToWriter
    );
  }
  f = message.getInviteDate();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getOverallScore();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getRating();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getSkillScoresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.io.codedrills.proto.user.SkillScore.serializeBinaryToWriter
    );
  }
  f = message.getAntiCheatingReport();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.io.codedrills.proto.user.AntiCheatingReport.serializeBinaryToWriter
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTestStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
};


/**
 * optional string candidate_id = 12;
 * @return {string}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getCandidateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.setCandidateId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int32 test_id = 13;
 * @return {number}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getTestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.setTestId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional CandidateProfile profile = 3;
 * @return {?proto.io.codedrills.proto.user.CandidateProfile}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getProfile = function() {
  return /** @type{?proto.io.codedrills.proto.user.CandidateProfile} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.CandidateProfile, 3));
};


/**
 * @param {?proto.io.codedrills.proto.user.CandidateProfile|undefined} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
*/
proto.io.codedrills.proto.user.CandidateReport.prototype.setProfile = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.clearProfile = function() {
  return this.setProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.hasProfile = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CandidateStage stage = 4;
 * @return {!proto.io.codedrills.proto.user.CandidateStage}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getStage = function() {
  return /** @type {!proto.io.codedrills.proto.user.CandidateStage} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.CandidateStage} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.setStage = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional TimeInfo test_time_info = 5;
 * @return {?proto.io.codedrills.proto.user.TimeInfo}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getTestTimeInfo = function() {
  return /** @type{?proto.io.codedrills.proto.user.TimeInfo} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.TimeInfo, 5));
};


/**
 * @param {?proto.io.codedrills.proto.user.TimeInfo|undefined} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
*/
proto.io.codedrills.proto.user.CandidateReport.prototype.setTestTimeInfo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.clearTestTimeInfo = function() {
  return this.setTestTimeInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.hasTestTimeInfo = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 invite_date = 6;
 * @return {number}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getInviteDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.setInviteDate = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double overall_score = 7;
 * @return {number}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getOverallScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.setOverallScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional int32 rating = 8;
 * @return {number}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getRating = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.setRating = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated SkillScore skill_scores = 9;
 * @return {!Array<!proto.io.codedrills.proto.user.SkillScore>}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getSkillScoresList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.SkillScore>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.SkillScore, 9));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.SkillScore>} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
*/
proto.io.codedrills.proto.user.CandidateReport.prototype.setSkillScoresList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.SkillScore=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.SkillScore}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.addSkillScores = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.io.codedrills.proto.user.SkillScore, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.clearSkillScoresList = function() {
  return this.setSkillScoresList([]);
};


/**
 * optional AntiCheatingReport anti_cheating_report = 10;
 * @return {?proto.io.codedrills.proto.user.AntiCheatingReport}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getAntiCheatingReport = function() {
  return /** @type{?proto.io.codedrills.proto.user.AntiCheatingReport} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.AntiCheatingReport, 10));
};


/**
 * @param {?proto.io.codedrills.proto.user.AntiCheatingReport|undefined} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
*/
proto.io.codedrills.proto.user.CandidateReport.prototype.setAntiCheatingReport = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.clearAntiCheatingReport = function() {
  return this.setAntiCheatingReport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.hasAntiCheatingReport = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string notes = 11;
 * @return {string}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional TestStatus test_status = 14;
 * @return {!proto.io.codedrills.proto.user.TestStatus}
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.getTestStatus = function() {
  return /** @type {!proto.io.codedrills.proto.user.TestStatus} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.TestStatus} value
 * @return {!proto.io.codedrills.proto.user.CandidateReport} returns this
 */
proto.io.codedrills.proto.user.CandidateReport.prototype.setTestStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.AntiCheatingReport.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.AntiCheatingReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.AntiCheatingReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.AntiCheatingReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    tabSwitchCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    windowSwitchCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    fullScreenExitCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    disconnectedCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    proctoringLogsList: jspb.Message.toObjectList(msg.getProctoringLogsList(),
    proto.io.codedrills.proto.user.ProctoringLog.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.AntiCheatingReport}
 */
proto.io.codedrills.proto.user.AntiCheatingReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.AntiCheatingReport;
  return proto.io.codedrills.proto.user.AntiCheatingReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.AntiCheatingReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.AntiCheatingReport}
 */
proto.io.codedrills.proto.user.AntiCheatingReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTabSwitchCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWindowSwitchCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFullScreenExitCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisconnectedCount(value);
      break;
    case 5:
      var value = new proto.io.codedrills.proto.user.ProctoringLog;
      reader.readMessage(value,proto.io.codedrills.proto.user.ProctoringLog.deserializeBinaryFromReader);
      msg.addProctoringLogs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.AntiCheatingReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.AntiCheatingReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.AntiCheatingReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTabSwitchCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getWindowSwitchCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFullScreenExitCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDisconnectedCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getProctoringLogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.io.codedrills.proto.user.ProctoringLog.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 tab_switch_count = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.getTabSwitchCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.AntiCheatingReport} returns this
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.setTabSwitchCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 window_switch_count = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.getWindowSwitchCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.AntiCheatingReport} returns this
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.setWindowSwitchCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 full_screen_exit_count = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.getFullScreenExitCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.AntiCheatingReport} returns this
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.setFullScreenExitCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 disconnected_count = 4;
 * @return {number}
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.getDisconnectedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.AntiCheatingReport} returns this
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.setDisconnectedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated ProctoringLog proctoring_logs = 5;
 * @return {!Array<!proto.io.codedrills.proto.user.ProctoringLog>}
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.getProctoringLogsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.ProctoringLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.ProctoringLog, 5));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.ProctoringLog>} value
 * @return {!proto.io.codedrills.proto.user.AntiCheatingReport} returns this
*/
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.setProctoringLogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.ProctoringLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.ProctoringLog}
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.addProctoringLogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.io.codedrills.proto.user.ProctoringLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.AntiCheatingReport} returns this
 */
proto.io.codedrills.proto.user.AntiCheatingReport.prototype.clearProctoringLogsList = function() {
  return this.setProctoringLogsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.SkillScore.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.SkillScore.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.SkillScore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.SkillScore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.SkillScore.toObject = function(includeInstance, msg) {
  var f, obj = {
    skillPreview: (f = msg.getSkillPreview()) && io_codedrills_proto_content_preview_pb.ContentPreview.toObject(includeInstance, f),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    questionAnswerList: jspb.Message.toObjectList(msg.getQuestionAnswerList(),
    proto.io.codedrills.proto.user.QuestionAnswer.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.SkillScore}
 */
proto.io.codedrills.proto.user.SkillScore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.SkillScore;
  return proto.io.codedrills.proto.user.SkillScore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.SkillScore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.SkillScore}
 */
proto.io.codedrills.proto.user.SkillScore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.setSkillPreview(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.user.QuestionAnswer;
      reader.readMessage(value,proto.io.codedrills.proto.user.QuestionAnswer.deserializeBinaryFromReader);
      msg.addQuestionAnswer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.SkillScore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.SkillScore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.SkillScore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.SkillScore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkillPreview();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getQuestionAnswerList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.user.QuestionAnswer.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentPreview skill_preview = 1;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.user.SkillScore.prototype.getSkillPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.user.SkillScore} returns this
*/
proto.io.codedrills.proto.user.SkillScore.prototype.setSkillPreview = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.SkillScore} returns this
 */
proto.io.codedrills.proto.user.SkillScore.prototype.clearSkillPreview = function() {
  return this.setSkillPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.SkillScore.prototype.hasSkillPreview = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double score = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.SkillScore.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.SkillScore} returns this
 */
proto.io.codedrills.proto.user.SkillScore.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * repeated QuestionAnswer question_answer = 3;
 * @return {!Array<!proto.io.codedrills.proto.user.QuestionAnswer>}
 */
proto.io.codedrills.proto.user.SkillScore.prototype.getQuestionAnswerList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.QuestionAnswer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.QuestionAnswer, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.QuestionAnswer>} value
 * @return {!proto.io.codedrills.proto.user.SkillScore} returns this
*/
proto.io.codedrills.proto.user.SkillScore.prototype.setQuestionAnswerList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.QuestionAnswer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.QuestionAnswer}
 */
proto.io.codedrills.proto.user.SkillScore.prototype.addQuestionAnswer = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.user.QuestionAnswer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.SkillScore} returns this
 */
proto.io.codedrills.proto.user.SkillScore.prototype.clearQuestionAnswerList = function() {
  return this.setQuestionAnswerList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.QuestionAnswer.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.QuestionAnswer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.QuestionAnswer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.QuestionAnswer.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionView: (f = msg.getQuestionView()) && io_codedrills_proto_content_view_pb.ContentView.toObject(includeInstance, f),
    completeAnswerData: (f = msg.getCompleteAnswerData()) && proto.io.codedrills.proto.user.CompleteAnswerData.toObject(includeInstance, f),
    achievedScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    maxScore: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.QuestionAnswer}
 */
proto.io.codedrills.proto.user.QuestionAnswer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.QuestionAnswer;
  return proto.io.codedrills.proto.user.QuestionAnswer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.QuestionAnswer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.QuestionAnswer}
 */
proto.io.codedrills.proto.user.QuestionAnswer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_view_pb.ContentView;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.ContentView.deserializeBinaryFromReader);
      msg.setQuestionView(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.user.CompleteAnswerData;
      reader.readMessage(value,proto.io.codedrills.proto.user.CompleteAnswerData.deserializeBinaryFromReader);
      msg.setCompleteAnswerData(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAchievedScore(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.QuestionAnswer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.QuestionAnswer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.QuestionAnswer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.QuestionAnswer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionView();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_view_pb.ContentView.serializeBinaryToWriter
    );
  }
  f = message.getCompleteAnswerData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.user.CompleteAnswerData.serializeBinaryToWriter
    );
  }
  f = message.getAchievedScore();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getMaxScore();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentView question_view = 1;
 * @return {?proto.io.codedrills.proto.content.ContentView}
 */
proto.io.codedrills.proto.user.QuestionAnswer.prototype.getQuestionView = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentView} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_view_pb.ContentView, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentView|undefined} value
 * @return {!proto.io.codedrills.proto.user.QuestionAnswer} returns this
*/
proto.io.codedrills.proto.user.QuestionAnswer.prototype.setQuestionView = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.QuestionAnswer} returns this
 */
proto.io.codedrills.proto.user.QuestionAnswer.prototype.clearQuestionView = function() {
  return this.setQuestionView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.QuestionAnswer.prototype.hasQuestionView = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CompleteAnswerData complete_answer_data = 2;
 * @return {?proto.io.codedrills.proto.user.CompleteAnswerData}
 */
proto.io.codedrills.proto.user.QuestionAnswer.prototype.getCompleteAnswerData = function() {
  return /** @type{?proto.io.codedrills.proto.user.CompleteAnswerData} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.CompleteAnswerData, 2));
};


/**
 * @param {?proto.io.codedrills.proto.user.CompleteAnswerData|undefined} value
 * @return {!proto.io.codedrills.proto.user.QuestionAnswer} returns this
*/
proto.io.codedrills.proto.user.QuestionAnswer.prototype.setCompleteAnswerData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.QuestionAnswer} returns this
 */
proto.io.codedrills.proto.user.QuestionAnswer.prototype.clearCompleteAnswerData = function() {
  return this.setCompleteAnswerData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.QuestionAnswer.prototype.hasCompleteAnswerData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double achieved_score = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.QuestionAnswer.prototype.getAchievedScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.QuestionAnswer} returns this
 */
proto.io.codedrills.proto.user.QuestionAnswer.prototype.setAchievedScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int32 max_score = 4;
 * @return {number}
 */
proto.io.codedrills.proto.user.QuestionAnswer.prototype.getMaxScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.QuestionAnswer} returns this
 */
proto.io.codedrills.proto.user.QuestionAnswer.prototype.setMaxScore = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.user.CompleteAnswerData.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.CompleteAnswerData.AnswerCase = {
  ANSWER_NOT_SET: 0,
  MCQ_ANSWER_DATA: 1,
  SUBJECTIVE_ANSWER_DATA: 2,
  PROBLEM_ANSWER_DATA: 3
};

/**
 * @return {proto.io.codedrills.proto.user.CompleteAnswerData.AnswerCase}
 */
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.getAnswerCase = function() {
  return /** @type {proto.io.codedrills.proto.user.CompleteAnswerData.AnswerCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.user.CompleteAnswerData.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CompleteAnswerData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CompleteAnswerData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CompleteAnswerData.toObject = function(includeInstance, msg) {
  var f, obj = {
    mcqAnswerData: (f = msg.getMcqAnswerData()) && proto.io.codedrills.proto.user.CompleteMcqAnswerData.toObject(includeInstance, f),
    subjectiveAnswerData: (f = msg.getSubjectiveAnswerData()) && proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.toObject(includeInstance, f),
    problemAnswerData: (f = msg.getProblemAnswerData()) && proto.io.codedrills.proto.user.CompleteProblemAnswerData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CompleteAnswerData}
 */
proto.io.codedrills.proto.user.CompleteAnswerData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CompleteAnswerData;
  return proto.io.codedrills.proto.user.CompleteAnswerData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CompleteAnswerData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CompleteAnswerData}
 */
proto.io.codedrills.proto.user.CompleteAnswerData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.user.CompleteMcqAnswerData;
      reader.readMessage(value,proto.io.codedrills.proto.user.CompleteMcqAnswerData.deserializeBinaryFromReader);
      msg.setMcqAnswerData(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData;
      reader.readMessage(value,proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.deserializeBinaryFromReader);
      msg.setSubjectiveAnswerData(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.user.CompleteProblemAnswerData;
      reader.readMessage(value,proto.io.codedrills.proto.user.CompleteProblemAnswerData.deserializeBinaryFromReader);
      msg.setProblemAnswerData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CompleteAnswerData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CompleteAnswerData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CompleteAnswerData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMcqAnswerData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.user.CompleteMcqAnswerData.serializeBinaryToWriter
    );
  }
  f = message.getSubjectiveAnswerData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.serializeBinaryToWriter
    );
  }
  f = message.getProblemAnswerData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.io.codedrills.proto.user.CompleteProblemAnswerData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CompleteMcqAnswerData mcq_answer_data = 1;
 * @return {?proto.io.codedrills.proto.user.CompleteMcqAnswerData}
 */
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.getMcqAnswerData = function() {
  return /** @type{?proto.io.codedrills.proto.user.CompleteMcqAnswerData} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.CompleteMcqAnswerData, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.CompleteMcqAnswerData|undefined} value
 * @return {!proto.io.codedrills.proto.user.CompleteAnswerData} returns this
*/
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.setMcqAnswerData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.io.codedrills.proto.user.CompleteAnswerData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CompleteAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.clearMcqAnswerData = function() {
  return this.setMcqAnswerData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.hasMcqAnswerData = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CompleteSubjectiveAnswerData subjective_answer_data = 2;
 * @return {?proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData}
 */
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.getSubjectiveAnswerData = function() {
  return /** @type{?proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData, 2));
};


/**
 * @param {?proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData|undefined} value
 * @return {!proto.io.codedrills.proto.user.CompleteAnswerData} returns this
*/
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.setSubjectiveAnswerData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.io.codedrills.proto.user.CompleteAnswerData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CompleteAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.clearSubjectiveAnswerData = function() {
  return this.setSubjectiveAnswerData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.hasSubjectiveAnswerData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CompleteProblemAnswerData problem_answer_data = 3;
 * @return {?proto.io.codedrills.proto.user.CompleteProblemAnswerData}
 */
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.getProblemAnswerData = function() {
  return /** @type{?proto.io.codedrills.proto.user.CompleteProblemAnswerData} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.CompleteProblemAnswerData, 3));
};


/**
 * @param {?proto.io.codedrills.proto.user.CompleteProblemAnswerData|undefined} value
 * @return {!proto.io.codedrills.proto.user.CompleteAnswerData} returns this
*/
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.setProblemAnswerData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.io.codedrills.proto.user.CompleteAnswerData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CompleteAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.clearProblemAnswerData = function() {
  return this.setProblemAnswerData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CompleteAnswerData.prototype.hasProblemAnswerData = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CompleteMcqAnswerData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CompleteMcqAnswerData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.toObject = function(includeInstance, msg) {
  var f, obj = {
    optionIdList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    correctOptionIdList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CompleteMcqAnswerData}
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CompleteMcqAnswerData;
  return proto.io.codedrills.proto.user.CompleteMcqAnswerData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CompleteMcqAnswerData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CompleteMcqAnswerData}
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addOptionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addCorrectOptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CompleteMcqAnswerData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CompleteMcqAnswerData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getCorrectOptionIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string option_id = 1;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.prototype.getOptionIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.user.CompleteMcqAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.prototype.setOptionIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.CompleteMcqAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.prototype.addOptionId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.CompleteMcqAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.prototype.clearOptionIdList = function() {
  return this.setOptionIdList([]);
};


/**
 * repeated string correct_option_id = 2;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.prototype.getCorrectOptionIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.user.CompleteMcqAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.prototype.setCorrectOptionIdList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.CompleteMcqAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.prototype.addCorrectOptionId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.CompleteMcqAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteMcqAnswerData.prototype.clearCorrectOptionIdList = function() {
  return this.setCorrectOptionIdList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.toObject = function(includeInstance, msg) {
  var f, obj = {
    subjectiveAnswer: jspb.Message.getFieldWithDefault(msg, 1, ""),
    expectedAnswer: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData}
 */
proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData;
  return proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData}
 */
proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubjectiveAnswer(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpectedAnswer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubjectiveAnswer();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpectedAnswer();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string subjective_answer = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.prototype.getSubjectiveAnswer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.prototype.setSubjectiveAnswer = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string expected_answer = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.prototype.getExpectedAnswer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteSubjectiveAnswerData.prototype.setExpectedAnswer = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CompleteProblemAnswerData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CompleteProblemAnswerData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.toObject = function(includeInstance, msg) {
  var f, obj = {
    bestSubmissionPreview: (f = msg.getBestSubmissionPreview()) && io_codedrills_proto_content_preview_pb.SubmissionPreview.toObject(includeInstance, f),
    submissionPreviewList: jspb.Message.toObjectList(msg.getSubmissionPreviewList(),
    io_codedrills_proto_content_preview_pb.SubmissionPreview.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CompleteProblemAnswerData}
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CompleteProblemAnswerData;
  return proto.io.codedrills.proto.user.CompleteProblemAnswerData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CompleteProblemAnswerData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CompleteProblemAnswerData}
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.SubmissionPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.SubmissionPreview.deserializeBinaryFromReader);
      msg.setBestSubmissionPreview(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_preview_pb.SubmissionPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.SubmissionPreview.deserializeBinaryFromReader);
      msg.addSubmissionPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CompleteProblemAnswerData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CompleteProblemAnswerData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBestSubmissionPreview();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.SubmissionPreview.serializeBinaryToWriter
    );
  }
  f = message.getSubmissionPreviewList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      io_codedrills_proto_content_preview_pb.SubmissionPreview.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.SubmissionPreview best_submission_preview = 1;
 * @return {?proto.io.codedrills.proto.content.SubmissionPreview}
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.prototype.getBestSubmissionPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.SubmissionPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.SubmissionPreview, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.SubmissionPreview|undefined} value
 * @return {!proto.io.codedrills.proto.user.CompleteProblemAnswerData} returns this
*/
proto.io.codedrills.proto.user.CompleteProblemAnswerData.prototype.setBestSubmissionPreview = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CompleteProblemAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.prototype.clearBestSubmissionPreview = function() {
  return this.setBestSubmissionPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.prototype.hasBestSubmissionPreview = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated io.codedrills.proto.content.SubmissionPreview submission_preview = 2;
 * @return {!Array<!proto.io.codedrills.proto.content.SubmissionPreview>}
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.prototype.getSubmissionPreviewList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.SubmissionPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_preview_pb.SubmissionPreview, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.SubmissionPreview>} value
 * @return {!proto.io.codedrills.proto.user.CompleteProblemAnswerData} returns this
*/
proto.io.codedrills.proto.user.CompleteProblemAnswerData.prototype.setSubmissionPreviewList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.SubmissionPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview}
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.prototype.addSubmissionPreview = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.content.SubmissionPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.CompleteProblemAnswerData} returns this
 */
proto.io.codedrills.proto.user.CompleteProblemAnswerData.prototype.clearSubmissionPreviewList = function() {
  return this.setSubmissionPreviewList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.TestQuestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.TestQuestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.TestQuestion.toObject = function(includeInstance, msg) {
  var f, obj = {
    testId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    candidateId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orderId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    questionId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    timeInfo: (f = msg.getTimeInfo()) && proto.io.codedrills.proto.user.TimeInfo.toObject(includeInstance, f),
    languageRestriction: (f = msg.getLanguageRestriction()) && io_codedrills_proto_content_content_pb.LanguageRestriction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.TestQuestion}
 */
proto.io.codedrills.proto.user.TestQuestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.TestQuestion;
  return proto.io.codedrills.proto.user.TestQuestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.TestQuestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.TestQuestion}
 */
proto.io.codedrills.proto.user.TestQuestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCandidateId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionId(value);
      break;
    case 5:
      var value = new proto.io.codedrills.proto.user.TimeInfo;
      reader.readMessage(value,proto.io.codedrills.proto.user.TimeInfo.deserializeBinaryFromReader);
      msg.setTimeInfo(value);
      break;
    case 6:
      var value = new io_codedrills_proto_content_content_pb.LanguageRestriction;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.LanguageRestriction.deserializeBinaryFromReader);
      msg.setLanguageRestriction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.TestQuestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.TestQuestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.TestQuestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTestId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCandidateId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getQuestionId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTimeInfo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.io.codedrills.proto.user.TimeInfo.serializeBinaryToWriter
    );
  }
  f = message.getLanguageRestriction();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      io_codedrills_proto_content_content_pb.LanguageRestriction.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 test_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.getTestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TestQuestion} returns this
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.setTestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string candidate_id = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.getCandidateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.TestQuestion} returns this
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.setCandidateId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 order_id = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.getOrderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TestQuestion} returns this
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 question_id = 4;
 * @return {number}
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.getQuestionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TestQuestion} returns this
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional TimeInfo time_info = 5;
 * @return {?proto.io.codedrills.proto.user.TimeInfo}
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.getTimeInfo = function() {
  return /** @type{?proto.io.codedrills.proto.user.TimeInfo} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.TimeInfo, 5));
};


/**
 * @param {?proto.io.codedrills.proto.user.TimeInfo|undefined} value
 * @return {!proto.io.codedrills.proto.user.TestQuestion} returns this
*/
proto.io.codedrills.proto.user.TestQuestion.prototype.setTimeInfo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.TestQuestion} returns this
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.clearTimeInfo = function() {
  return this.setTimeInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.hasTimeInfo = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional io.codedrills.proto.content.LanguageRestriction language_restriction = 6;
 * @return {?proto.io.codedrills.proto.content.LanguageRestriction}
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.getLanguageRestriction = function() {
  return /** @type{?proto.io.codedrills.proto.content.LanguageRestriction} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.LanguageRestriction, 6));
};


/**
 * @param {?proto.io.codedrills.proto.content.LanguageRestriction|undefined} value
 * @return {!proto.io.codedrills.proto.user.TestQuestion} returns this
*/
proto.io.codedrills.proto.user.TestQuestion.prototype.setLanguageRestriction = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.TestQuestion} returns this
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.clearLanguageRestriction = function() {
  return this.setLanguageRestriction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.TestQuestion.prototype.hasLanguageRestriction = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.TimeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.TimeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.TimeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.TimeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    startedAt: jspb.Message.getFieldWithDefault(msg, 1, 0),
    endedAt: jspb.Message.getFieldWithDefault(msg, 2, 0),
    duration: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.TimeInfo}
 */
proto.io.codedrills.proto.user.TimeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.TimeInfo;
  return proto.io.codedrills.proto.user.TimeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.TimeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.TimeInfo}
 */
proto.io.codedrills.proto.user.TimeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartedAt(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndedAt(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.TimeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.TimeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.TimeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.TimeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartedAt();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEndedAt();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 started_at = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.TimeInfo.prototype.getStartedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TimeInfo} returns this
 */
proto.io.codedrills.proto.user.TimeInfo.prototype.setStartedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 ended_at = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.TimeInfo.prototype.getEndedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TimeInfo} returns this
 */
proto.io.codedrills.proto.user.TimeInfo.prototype.setEndedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 duration = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.TimeInfo.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TimeInfo} returns this
 */
proto.io.codedrills.proto.user.TimeInfo.prototype.setDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Answer.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Answer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Answer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Answer.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    candidateId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    parentId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    answerData: (f = msg.getAnswerData()) && proto.io.codedrills.proto.user.AnswerData.toObject(includeInstance, f),
    contentType: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Answer}
 */
proto.io.codedrills.proto.user.Answer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Answer;
  return proto.io.codedrills.proto.user.Answer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Answer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Answer}
 */
proto.io.codedrills.proto.user.Answer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCandidateId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setParentId(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.user.AnswerData;
      reader.readMessage(value,proto.io.codedrills.proto.user.AnswerData.deserializeBinaryFromReader);
      msg.setAnswerData(value);
      break;
    case 5:
      var value = /** @type {!proto.io.codedrills.proto.content.ContentType} */ (reader.readEnum());
      msg.setContentType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Answer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Answer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Answer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Answer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCandidateId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParentId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAnswerData();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.io.codedrills.proto.user.AnswerData.serializeBinaryToWriter
    );
  }
  f = message.getContentType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int32 question_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.Answer.prototype.getQuestionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Answer} returns this
 */
proto.io.codedrills.proto.user.Answer.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string candidate_id = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.Answer.prototype.getCandidateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Answer} returns this
 */
proto.io.codedrills.proto.user.Answer.prototype.setCandidateId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 parent_id = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.Answer.prototype.getParentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Answer} returns this
 */
proto.io.codedrills.proto.user.Answer.prototype.setParentId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional AnswerData answer_data = 4;
 * @return {?proto.io.codedrills.proto.user.AnswerData}
 */
proto.io.codedrills.proto.user.Answer.prototype.getAnswerData = function() {
  return /** @type{?proto.io.codedrills.proto.user.AnswerData} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.AnswerData, 4));
};


/**
 * @param {?proto.io.codedrills.proto.user.AnswerData|undefined} value
 * @return {!proto.io.codedrills.proto.user.Answer} returns this
*/
proto.io.codedrills.proto.user.Answer.prototype.setAnswerData = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Answer} returns this
 */
proto.io.codedrills.proto.user.Answer.prototype.clearAnswerData = function() {
  return this.setAnswerData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Answer.prototype.hasAnswerData = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional io.codedrills.proto.content.ContentType content_type = 5;
 * @return {!proto.io.codedrills.proto.content.ContentType}
 */
proto.io.codedrills.proto.user.Answer.prototype.getContentType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContentType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @return {!proto.io.codedrills.proto.user.Answer} returns this
 */
proto.io.codedrills.proto.user.Answer.prototype.setContentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.user.AnswerData.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.AnswerData.AnswerDataCase = {
  ANSWER_DATA_NOT_SET: 0,
  MCQ_ANSWER_DATA: 1,
  SUBJECTIVE_ANSWER_DATA: 2,
  PROBLEM_ANSWER_DATA: 3
};

/**
 * @return {proto.io.codedrills.proto.user.AnswerData.AnswerDataCase}
 */
proto.io.codedrills.proto.user.AnswerData.prototype.getAnswerDataCase = function() {
  return /** @type {proto.io.codedrills.proto.user.AnswerData.AnswerDataCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.user.AnswerData.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.AnswerData.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.AnswerData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.AnswerData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.AnswerData.toObject = function(includeInstance, msg) {
  var f, obj = {
    mcqAnswerData: (f = msg.getMcqAnswerData()) && proto.io.codedrills.proto.user.McqAnswerData.toObject(includeInstance, f),
    subjectiveAnswerData: (f = msg.getSubjectiveAnswerData()) && proto.io.codedrills.proto.user.SubjectiveAnswerData.toObject(includeInstance, f),
    problemAnswerData: (f = msg.getProblemAnswerData()) && proto.io.codedrills.proto.user.ProblemAnswerData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.AnswerData}
 */
proto.io.codedrills.proto.user.AnswerData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.AnswerData;
  return proto.io.codedrills.proto.user.AnswerData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.AnswerData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.AnswerData}
 */
proto.io.codedrills.proto.user.AnswerData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.user.McqAnswerData;
      reader.readMessage(value,proto.io.codedrills.proto.user.McqAnswerData.deserializeBinaryFromReader);
      msg.setMcqAnswerData(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.user.SubjectiveAnswerData;
      reader.readMessage(value,proto.io.codedrills.proto.user.SubjectiveAnswerData.deserializeBinaryFromReader);
      msg.setSubjectiveAnswerData(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.user.ProblemAnswerData;
      reader.readMessage(value,proto.io.codedrills.proto.user.ProblemAnswerData.deserializeBinaryFromReader);
      msg.setProblemAnswerData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.AnswerData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.AnswerData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.AnswerData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.AnswerData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMcqAnswerData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.user.McqAnswerData.serializeBinaryToWriter
    );
  }
  f = message.getSubjectiveAnswerData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.user.SubjectiveAnswerData.serializeBinaryToWriter
    );
  }
  f = message.getProblemAnswerData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.io.codedrills.proto.user.ProblemAnswerData.serializeBinaryToWriter
    );
  }
};


/**
 * optional McqAnswerData mcq_answer_data = 1;
 * @return {?proto.io.codedrills.proto.user.McqAnswerData}
 */
proto.io.codedrills.proto.user.AnswerData.prototype.getMcqAnswerData = function() {
  return /** @type{?proto.io.codedrills.proto.user.McqAnswerData} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.McqAnswerData, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.McqAnswerData|undefined} value
 * @return {!proto.io.codedrills.proto.user.AnswerData} returns this
*/
proto.io.codedrills.proto.user.AnswerData.prototype.setMcqAnswerData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.io.codedrills.proto.user.AnswerData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.AnswerData} returns this
 */
proto.io.codedrills.proto.user.AnswerData.prototype.clearMcqAnswerData = function() {
  return this.setMcqAnswerData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.AnswerData.prototype.hasMcqAnswerData = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SubjectiveAnswerData subjective_answer_data = 2;
 * @return {?proto.io.codedrills.proto.user.SubjectiveAnswerData}
 */
proto.io.codedrills.proto.user.AnswerData.prototype.getSubjectiveAnswerData = function() {
  return /** @type{?proto.io.codedrills.proto.user.SubjectiveAnswerData} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.SubjectiveAnswerData, 2));
};


/**
 * @param {?proto.io.codedrills.proto.user.SubjectiveAnswerData|undefined} value
 * @return {!proto.io.codedrills.proto.user.AnswerData} returns this
*/
proto.io.codedrills.proto.user.AnswerData.prototype.setSubjectiveAnswerData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.io.codedrills.proto.user.AnswerData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.AnswerData} returns this
 */
proto.io.codedrills.proto.user.AnswerData.prototype.clearSubjectiveAnswerData = function() {
  return this.setSubjectiveAnswerData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.AnswerData.prototype.hasSubjectiveAnswerData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ProblemAnswerData problem_answer_data = 3;
 * @return {?proto.io.codedrills.proto.user.ProblemAnswerData}
 */
proto.io.codedrills.proto.user.AnswerData.prototype.getProblemAnswerData = function() {
  return /** @type{?proto.io.codedrills.proto.user.ProblemAnswerData} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.ProblemAnswerData, 3));
};


/**
 * @param {?proto.io.codedrills.proto.user.ProblemAnswerData|undefined} value
 * @return {!proto.io.codedrills.proto.user.AnswerData} returns this
*/
proto.io.codedrills.proto.user.AnswerData.prototype.setProblemAnswerData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.io.codedrills.proto.user.AnswerData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.AnswerData} returns this
 */
proto.io.codedrills.proto.user.AnswerData.prototype.clearProblemAnswerData = function() {
  return this.setProblemAnswerData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.AnswerData.prototype.hasProblemAnswerData = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.McqAnswerData.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.McqAnswerData.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.McqAnswerData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.McqAnswerData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.McqAnswerData.toObject = function(includeInstance, msg) {
  var f, obj = {
    optionIdList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.McqAnswerData}
 */
proto.io.codedrills.proto.user.McqAnswerData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.McqAnswerData;
  return proto.io.codedrills.proto.user.McqAnswerData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.McqAnswerData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.McqAnswerData}
 */
proto.io.codedrills.proto.user.McqAnswerData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addOptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.McqAnswerData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.McqAnswerData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.McqAnswerData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.McqAnswerData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string option_id = 2;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.user.McqAnswerData.prototype.getOptionIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.user.McqAnswerData} returns this
 */
proto.io.codedrills.proto.user.McqAnswerData.prototype.setOptionIdList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.McqAnswerData} returns this
 */
proto.io.codedrills.proto.user.McqAnswerData.prototype.addOptionId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.McqAnswerData} returns this
 */
proto.io.codedrills.proto.user.McqAnswerData.prototype.clearOptionIdList = function() {
  return this.setOptionIdList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.SubjectiveAnswerData.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.SubjectiveAnswerData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.SubjectiveAnswerData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.SubjectiveAnswerData.toObject = function(includeInstance, msg) {
  var f, obj = {
    subjectiveAnswer: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.SubjectiveAnswerData}
 */
proto.io.codedrills.proto.user.SubjectiveAnswerData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.SubjectiveAnswerData;
  return proto.io.codedrills.proto.user.SubjectiveAnswerData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.SubjectiveAnswerData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.SubjectiveAnswerData}
 */
proto.io.codedrills.proto.user.SubjectiveAnswerData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubjectiveAnswer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.SubjectiveAnswerData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.SubjectiveAnswerData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.SubjectiveAnswerData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.SubjectiveAnswerData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubjectiveAnswer();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string subjective_answer = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.SubjectiveAnswerData.prototype.getSubjectiveAnswer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.SubjectiveAnswerData} returns this
 */
proto.io.codedrills.proto.user.SubjectiveAnswerData.prototype.setSubjectiveAnswer = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.ProblemAnswerData.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.ProblemAnswerData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.ProblemAnswerData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ProblemAnswerData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.ProblemAnswerData}
 */
proto.io.codedrills.proto.user.ProblemAnswerData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.ProblemAnswerData;
  return proto.io.codedrills.proto.user.ProblemAnswerData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.ProblemAnswerData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.ProblemAnswerData}
 */
proto.io.codedrills.proto.user.ProblemAnswerData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.ProblemAnswerData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.ProblemAnswerData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.ProblemAnswerData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ProblemAnswerData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.ProctoringLog.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.ProctoringLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.ProctoringLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ProctoringLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    timestamp: jspb.Message.getFieldWithDefault(msg, 1, 0),
    testId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    candidateId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    questionId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    proctoringEvent: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.ProctoringLog}
 */
proto.io.codedrills.proto.user.ProctoringLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.ProctoringLog;
  return proto.io.codedrills.proto.user.ProctoringLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.ProctoringLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.ProctoringLog}
 */
proto.io.codedrills.proto.user.ProctoringLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTestId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCandidateId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionId(value);
      break;
    case 5:
      var value = /** @type {!proto.io.codedrills.proto.user.ProctoringEvent} */ (reader.readEnum());
      msg.setProctoringEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.ProctoringLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.ProctoringLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.ProctoringLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ProctoringLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTestId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCandidateId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuestionId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getProctoringEvent();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int64 timestamp = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.ProctoringLog.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.ProctoringLog} returns this
 */
proto.io.codedrills.proto.user.ProctoringLog.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 test_id = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.ProctoringLog.prototype.getTestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.ProctoringLog} returns this
 */
proto.io.codedrills.proto.user.ProctoringLog.prototype.setTestId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string candidate_id = 3;
 * @return {string}
 */
proto.io.codedrills.proto.user.ProctoringLog.prototype.getCandidateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.ProctoringLog} returns this
 */
proto.io.codedrills.proto.user.ProctoringLog.prototype.setCandidateId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 question_id = 4;
 * @return {number}
 */
proto.io.codedrills.proto.user.ProctoringLog.prototype.getQuestionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.ProctoringLog} returns this
 */
proto.io.codedrills.proto.user.ProctoringLog.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional ProctoringEvent proctoring_event = 5;
 * @return {!proto.io.codedrills.proto.user.ProctoringEvent}
 */
proto.io.codedrills.proto.user.ProctoringLog.prototype.getProctoringEvent = function() {
  return /** @type {!proto.io.codedrills.proto.user.ProctoringEvent} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.ProctoringEvent} value
 * @return {!proto.io.codedrills.proto.user.ProctoringLog} returns this
 */
proto.io.codedrills.proto.user.ProctoringLog.prototype.setProctoringEvent = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CandidateFeedback.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CandidateFeedback.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CandidateFeedback} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CandidateFeedback.toObject = function(includeInstance, msg) {
  var f, obj = {
    assessmentStars: jspb.Message.getFieldWithDefault(msg, 1, 0),
    platformStars: jspb.Message.getFieldWithDefault(msg, 2, 0),
    writtenFeedback: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CandidateFeedback}
 */
proto.io.codedrills.proto.user.CandidateFeedback.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CandidateFeedback;
  return proto.io.codedrills.proto.user.CandidateFeedback.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CandidateFeedback} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CandidateFeedback}
 */
proto.io.codedrills.proto.user.CandidateFeedback.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssessmentStars(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlatformStars(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWrittenFeedback(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CandidateFeedback.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CandidateFeedback.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CandidateFeedback} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CandidateFeedback.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssessmentStars();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPlatformStars();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getWrittenFeedback();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 assessment_stars = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.CandidateFeedback.prototype.getAssessmentStars = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CandidateFeedback} returns this
 */
proto.io.codedrills.proto.user.CandidateFeedback.prototype.setAssessmentStars = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 platform_stars = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.CandidateFeedback.prototype.getPlatformStars = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CandidateFeedback} returns this
 */
proto.io.codedrills.proto.user.CandidateFeedback.prototype.setPlatformStars = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string written_feedback = 3;
 * @return {string}
 */
proto.io.codedrills.proto.user.CandidateFeedback.prototype.getWrittenFeedback = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CandidateFeedback} returns this
 */
proto.io.codedrills.proto.user.CandidateFeedback.prototype.setWrittenFeedback = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CurrentTestView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CurrentTestView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CurrentTestView.toObject = function(includeInstance, msg) {
  var f, obj = {
    testPreview: (f = msg.getTestPreview()) && io_codedrills_proto_content_preview_pb.ContentPreview.toObject(includeInstance, f),
    currentQuestionNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    questionView: (f = msg.getQuestionView()) && io_codedrills_proto_content_view_pb.ContentView.toObject(includeInstance, f),
    totalQuestions: jspb.Message.getFieldWithDefault(msg, 4, 0),
    testTimeInfo: (f = msg.getTestTimeInfo()) && proto.io.codedrills.proto.user.TimeInfo.toObject(includeInstance, f),
    questionTimeInfo: (f = msg.getQuestionTimeInfo()) && proto.io.codedrills.proto.user.TimeInfo.toObject(includeInstance, f),
    feedback: (f = msg.getFeedback()) && proto.io.codedrills.proto.user.CandidateFeedback.toObject(includeInstance, f),
    languageRestriction: (f = msg.getLanguageRestriction()) && io_codedrills_proto_content_content_pb.LanguageRestriction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CurrentTestView}
 */
proto.io.codedrills.proto.user.CurrentTestView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CurrentTestView;
  return proto.io.codedrills.proto.user.CurrentTestView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CurrentTestView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CurrentTestView}
 */
proto.io.codedrills.proto.user.CurrentTestView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.setTestPreview(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentQuestionNumber(value);
      break;
    case 3:
      var value = new io_codedrills_proto_content_view_pb.ContentView;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.ContentView.deserializeBinaryFromReader);
      msg.setQuestionView(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalQuestions(value);
      break;
    case 5:
      var value = new proto.io.codedrills.proto.user.TimeInfo;
      reader.readMessage(value,proto.io.codedrills.proto.user.TimeInfo.deserializeBinaryFromReader);
      msg.setTestTimeInfo(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.user.TimeInfo;
      reader.readMessage(value,proto.io.codedrills.proto.user.TimeInfo.deserializeBinaryFromReader);
      msg.setQuestionTimeInfo(value);
      break;
    case 7:
      var value = new proto.io.codedrills.proto.user.CandidateFeedback;
      reader.readMessage(value,proto.io.codedrills.proto.user.CandidateFeedback.deserializeBinaryFromReader);
      msg.setFeedback(value);
      break;
    case 8:
      var value = new io_codedrills_proto_content_content_pb.LanguageRestriction;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.LanguageRestriction.deserializeBinaryFromReader);
      msg.setLanguageRestriction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CurrentTestView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CurrentTestView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CurrentTestView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTestPreview();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
  f = message.getCurrentQuestionNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getQuestionView();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      io_codedrills_proto_content_view_pb.ContentView.serializeBinaryToWriter
    );
  }
  f = message.getTotalQuestions();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTestTimeInfo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.io.codedrills.proto.user.TimeInfo.serializeBinaryToWriter
    );
  }
  f = message.getQuestionTimeInfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.io.codedrills.proto.user.TimeInfo.serializeBinaryToWriter
    );
  }
  f = message.getFeedback();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.io.codedrills.proto.user.CandidateFeedback.serializeBinaryToWriter
    );
  }
  f = message.getLanguageRestriction();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      io_codedrills_proto_content_content_pb.LanguageRestriction.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentPreview test_preview = 1;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.getTestPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
*/
proto.io.codedrills.proto.user.CurrentTestView.prototype.setTestPreview = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.clearTestPreview = function() {
  return this.setTestPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.hasTestPreview = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 current_question_number = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.getCurrentQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.setCurrentQuestionNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional io.codedrills.proto.content.ContentView question_view = 3;
 * @return {?proto.io.codedrills.proto.content.ContentView}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.getQuestionView = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentView} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_view_pb.ContentView, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentView|undefined} value
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
*/
proto.io.codedrills.proto.user.CurrentTestView.prototype.setQuestionView = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.clearQuestionView = function() {
  return this.setQuestionView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.hasQuestionView = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 total_questions = 4;
 * @return {number}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.getTotalQuestions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.setTotalQuestions = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional TimeInfo test_time_info = 5;
 * @return {?proto.io.codedrills.proto.user.TimeInfo}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.getTestTimeInfo = function() {
  return /** @type{?proto.io.codedrills.proto.user.TimeInfo} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.TimeInfo, 5));
};


/**
 * @param {?proto.io.codedrills.proto.user.TimeInfo|undefined} value
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
*/
proto.io.codedrills.proto.user.CurrentTestView.prototype.setTestTimeInfo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.clearTestTimeInfo = function() {
  return this.setTestTimeInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.hasTestTimeInfo = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional TimeInfo question_time_info = 6;
 * @return {?proto.io.codedrills.proto.user.TimeInfo}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.getQuestionTimeInfo = function() {
  return /** @type{?proto.io.codedrills.proto.user.TimeInfo} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.TimeInfo, 6));
};


/**
 * @param {?proto.io.codedrills.proto.user.TimeInfo|undefined} value
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
*/
proto.io.codedrills.proto.user.CurrentTestView.prototype.setQuestionTimeInfo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.clearQuestionTimeInfo = function() {
  return this.setQuestionTimeInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.hasQuestionTimeInfo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional CandidateFeedback feedback = 7;
 * @return {?proto.io.codedrills.proto.user.CandidateFeedback}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.getFeedback = function() {
  return /** @type{?proto.io.codedrills.proto.user.CandidateFeedback} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.CandidateFeedback, 7));
};


/**
 * @param {?proto.io.codedrills.proto.user.CandidateFeedback|undefined} value
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
*/
proto.io.codedrills.proto.user.CurrentTestView.prototype.setFeedback = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.clearFeedback = function() {
  return this.setFeedback(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.hasFeedback = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional io.codedrills.proto.content.LanguageRestriction language_restriction = 8;
 * @return {?proto.io.codedrills.proto.content.LanguageRestriction}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.getLanguageRestriction = function() {
  return /** @type{?proto.io.codedrills.proto.content.LanguageRestriction} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.LanguageRestriction, 8));
};


/**
 * @param {?proto.io.codedrills.proto.content.LanguageRestriction|undefined} value
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
*/
proto.io.codedrills.proto.user.CurrentTestView.prototype.setLanguageRestriction = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CurrentTestView} returns this
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.clearLanguageRestriction = function() {
  return this.setLanguageRestriction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CurrentTestView.prototype.hasLanguageRestriction = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Resume.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Resume.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Resume} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Resume.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Resume}
 */
proto.io.codedrills.proto.user.Resume.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Resume;
  return proto.io.codedrills.proto.user.Resume.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Resume} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Resume}
 */
proto.io.codedrills.proto.user.Resume.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Resume.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Resume.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Resume} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Resume.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.Resume.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Resume} returns this
 */
proto.io.codedrills.proto.user.Resume.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.Resume.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Resume} returns this
 */
proto.io.codedrills.proto.user.Resume.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.JobCandidate.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.JobCandidate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.JobCandidate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.JobCandidate.toObject = function(includeInstance, msg) {
  var f, obj = {
    resume: (f = msg.getResume()) && proto.io.codedrills.proto.user.Resume.toObject(includeInstance, f),
    appliedOn: jspb.Message.getFieldWithDefault(msg, 2, 0),
    uploadedResumeUrl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.JobCandidate}
 */
proto.io.codedrills.proto.user.JobCandidate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.JobCandidate;
  return proto.io.codedrills.proto.user.JobCandidate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.JobCandidate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.JobCandidate}
 */
proto.io.codedrills.proto.user.JobCandidate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.user.Resume;
      reader.readMessage(value,proto.io.codedrills.proto.user.Resume.deserializeBinaryFromReader);
      msg.setResume(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAppliedOn(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadedResumeUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.JobCandidate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.JobCandidate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.JobCandidate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.JobCandidate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResume();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.user.Resume.serializeBinaryToWriter
    );
  }
  f = message.getAppliedOn();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUploadedResumeUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional Resume resume = 1;
 * @return {?proto.io.codedrills.proto.user.Resume}
 */
proto.io.codedrills.proto.user.JobCandidate.prototype.getResume = function() {
  return /** @type{?proto.io.codedrills.proto.user.Resume} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.Resume, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.Resume|undefined} value
 * @return {!proto.io.codedrills.proto.user.JobCandidate} returns this
*/
proto.io.codedrills.proto.user.JobCandidate.prototype.setResume = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.JobCandidate} returns this
 */
proto.io.codedrills.proto.user.JobCandidate.prototype.clearResume = function() {
  return this.setResume(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.JobCandidate.prototype.hasResume = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 applied_on = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.JobCandidate.prototype.getAppliedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.JobCandidate} returns this
 */
proto.io.codedrills.proto.user.JobCandidate.prototype.setAppliedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string uploaded_resume_url = 3;
 * @return {string}
 */
proto.io.codedrills.proto.user.JobCandidate.prototype.getUploadedResumeUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.JobCandidate} returns this
 */
proto.io.codedrills.proto.user.JobCandidate.prototype.setUploadedResumeUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.ProctoringEvent = {
  PROCTORING_EVENT_UNKNOWN: 0,
  PROCTORING_EVENT_TAB_SWITCH: 1,
  PROCTORING_EVENT_WINDOW_SWITCH: 2,
  PROCTORING_EVENT_FULL_SCREEN_EXIT: 3,
  PROCTORING_EVENT_DISCONNECTED: 4
};

goog.object.extend(exports, proto.io.codedrills.proto.user);
